import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const dateTimeInputViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map